export default __webpack_public_path__ + "static/media/pixelapse.b875e38c.svg";